import { ProForm } from '@ant-design/pro-form';
import { Select, DatePicker, SelectProps } from 'antd';
import { RangePickerProps } from 'antd/lib/date-picker';
import { Moment } from 'moment';
import React, { FC, useState } from 'react';
import { DateTimeRangeFormType } from '@/presentation/components/form';
import styles from '@/presentation/components/form/components/date-time-range.module.scss';
import { Option } from '@/proto/field';

export interface IValue {
  timeQuick?: string | Option,
  timeRange?: [Moment | null, Moment | null] | null
}
interface IProps {
  entry: DateTimeRangeFormType
}
interface DateTimeProps {
  entry: DateTimeRangeFormType;
  value?: IValue,
  onChange?: (value: IValue) => void;
}

const { RangePicker } = DatePicker;
const FormItem = ProForm.Item;

const DateTime = (props: DateTimeProps) => {
  const { entry, value, onChange } = props;
  const { timeQuickProps, rangePickerProps } = entry;
  const { timeQuickOnChange, ...resTimeQuickProps } = timeQuickProps || {};
  const { rangePickerOnChange, ...resRangePickerProps } = rangePickerProps || {};
  const [updateTimeQuickProps, setUpdateTimeQuickProps] = useState<SelectProps<string | Option, Option>>({});
  const [updateRangePickerProps, setUpdateRangePickerProps] = useState<RangePickerProps>({});

  // 操作快捷选项
  const timeQuickChange = (timeQuickValue: (string | Option), option: Option | Option[]) => {
    onChange?.({ ...value, timeQuick: timeQuickValue });
    timeQuickOnChange?.(timeQuickValue, option, setUpdateTimeQuickProps, setUpdateRangePickerProps);
  };

  const rangePickerChange = (values: [Moment | null, Moment | null] | null) => {
    onChange?.({ ...value, timeRange: values });
    rangePickerOnChange?.(values);
  };


  return <div className={styles.dateTimeRange}>
  <Select
      {...resTimeQuickProps}
      {...updateTimeQuickProps}
      value={value?.timeQuick}
      className={styles.timeQuick}
      onChange={timeQuickChange}
  />
  <RangePicker
      {...resRangePickerProps}
      {...updateRangePickerProps}
      value={value?.timeRange}
      className={styles.timeRange} onChange={rangePickerChange}/>
</div>;
};

export const DateTimeRange: FC<IProps> = (props: IProps) => {
  const { entry } = props;
  const { label, name } = entry;

  return <FormItem label={label} name={name}>
    <DateTime entry={entry}/>
  </FormItem>;
};
